import { useState, useEffect } from "react";
import { getData } from "../../../services/library";
import moment from "moment";
import { UrlApi } from "../../../services/apirest";
import { method } from "lodash";

const estilosModal = {
  modal: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  contenido: {
    backgroundColor: "white",
    padding: "20px",
    borderRadius: "8px",
    width: "80%",
    maxWidth: "800px",
    maxHeight: "80%",
    overflow: "auto",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
  },
  encabezado: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },
  titulo: {
    fontSize: "20px",
    fontWeight: "bold",
    margin: 0,
  },
  botonCerrar: {
    backgroundColor: "transparent",
    border: "none",
    fontSize: "20px",
    cursor: "pointer",
  },
  tabla: {
    width: "100%",
    borderCollapse: "collapse",
  },
  encabezadoTabla: {
    backgroundColor: "#f2f2f2",
    textAlign: "left",
    position: "sticky",
    top: 0,
    zIndex: 1,
  },
  celdaEncabezado: {
    padding: "12px 15px",
    borderBottom: "1px solid #ddd",
    backgroundColor: "#f2f2f2",
  },
  fila: {
    cursor: "pointer",
  },
  filaSeleccionada: {
    backgroundColor: "#e6f7ff",
  },
  celda: {
    padding: "12px 15px",
    borderBottom: "1px solid #ddd",
  },
  celdaRadio: {
    width: "40px",
    textAlign: "center",
  },
  radioPersonalizado: {
    height: "18px",
    width: "18px",
    backgroundColor: "white",
    borderRadius: "50%",
    border: "2px solid #ddd",
    display: "inline-block",
    position: "relative",
  },
  radioSeleccionado: {
    border: "2px solid #1890ff",
  },
  radioPunto: {
    height: "10px",
    width: "10px",
    backgroundColor: "#1890ff",
    borderRadius: "50%",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  footer: {
    marginTop: "20px",
    display: "flex",
    justifyContent: "flex-end",
  },
  boton: {
    padding: "8px 16px",
    marginLeft: "10px",
    borderRadius: "4px",
    cursor: "pointer",
    border: "none",
  },
  botonPrimario: {
    backgroundColor: "#1890ff",
    color: "white",
  },
  botonSecundario: {
    backgroundColor: "#f0f0f0",
    border: "1px solid #d9d9d9",
  },
};
const ModalCambioSolicitud = ({
  open,
  onClose,
  mostrarAlertaTemporal,
  idCandidato,
  obtenerCandidatos,
}) => {
  const [filaSeleccionada, setFilaSeleccionada] = useState(null);
  const [datosTabla, setDatosTabla] = useState([]);

  useEffect(() => {
    if (open) {
      console.log("Modal montado, ID del candidato:", idCandidato);
      getData("/solicitudDePersonal/solicitudesParaElCambio/prueba", (data) => {
        console.log("Datos cargados:", data);
        setDatosTabla(data);
      });
    }
  }, [open]);

  if (!open) return null;

  const seleccionarFila = (id) => setFilaSeleccionada(id);

  const confirmarSeleccion = async (e) => {
    e.preventDefault();
    console.log("ID seleccionado:", filaSeleccionada);

    try {
      const response = await fetch(`${UrlApi}/SP_candidatos/${idCandidato}`, {
        headers: {
          "Content-Type": "application/json",
        },
        method: "PUT",
        body: JSON.stringify({ id_solicitud_a_aplicar: filaSeleccionada }),
      });

      if (!response.ok)
        mostrarAlertaTemporal(
          "Ocurrio un error al pasar el candidato a otra solicitud. Intentelo de nuevo",
          "error"
        );
      else
        mostrarAlertaTemporal(
          "El candidato se logro pasar con exito",
          "success"
        );
    } catch (err) {
      console.log(err);
    }
    obtenerCandidatos();
    onClose();
  };

  return (
    <div style={estilosModal.modal}>
      <div style={estilosModal.contenido}>
        <div style={estilosModal.encabezado}>
          <h2 style={estilosModal.titulo}>Seleccionar Registro</h2>
          <button style={estilosModal.botonCerrar} onClick={onClose}>
            ×
          </button>
        </div>
        <div style={{ maxHeight: "400px", overflowY: "auto" }}>
          <table style={estilosModal.tabla}>
            <thead style={estilosModal.encabezadoTabla}>
              <tr>
                <th style={estilosModal.celdaRadio}></th>
                <th style={estilosModal.celdaEncabezado}>ID</th>
                <th style={estilosModal.celdaEncabezado}>Puesto</th>
                <th style={estilosModal.celdaEncabezado}>Sucursal</th>
                <th style={estilosModal.celdaEncabezado}>Prioridad</th>
                <th style={estilosModal.celdaEncabezado}>Fecha Solicitud</th>
              </tr>
            </thead>

            <tbody style={{ overflowY: "auto", maxHeight: "500px" }}>
              {datosTabla.map((fila) => (
                <tr
                  key={fila.id}
                  style={{
                    ...estilosModal.fila,
                    ...(filaSeleccionada === fila.id
                      ? estilosModal.filaSeleccionada
                      : {}),
                  }}
                  onClick={() => seleccionarFila(fila.id)}
                >
                  <td style={estilosModal.celdaRadio}>
                    <div
                      style={{
                        ...estilosModal.radioPersonalizado,
                        ...(filaSeleccionada === fila.id
                          ? estilosModal.radioSeleccionado
                          : {}),
                      }}
                    >
                      {filaSeleccionada === fila.id && (
                        <div style={estilosModal.radioPunto}></div>
                      )}
                    </div>
                  </td>
                  <td style={estilosModal.celda}>{fila.id}</td>
                  <td style={estilosModal.celda}>{fila.puesto}</td>
                  <td style={estilosModal.celda}>{fila.sucursal}</td>
                  <td style={estilosModal.celda}>{fila.prioridad}</td>
                  <td style={estilosModal.celda}>
                    {moment(fila.fecha_solicitud).format("DD/MM/YYYY")}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div style={estilosModal.footer}>
          <button
            style={{ ...estilosModal.boton, ...estilosModal.botonSecundario }}
            onClick={onClose}
          >
            Cancelar
          </button>
          <button
            style={{ ...estilosModal.boton, ...estilosModal.botonPrimario }}
            onClick={confirmarSeleccion}
            disabled={filaSeleccionada === null}
          >
            Confirmar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalCambioSolicitud;
